/**
 * IT機器商品詳細ページ用JavaScript
 * ファイル名: assets/product-info-it.js
 */

// 画像切り替え機能
function changeMainImage(element, imageUrl) {
  const mainImage = document.getElementById('mainProductImage');
  if (mainImage && imageUrl) {
    mainImage.src = imageUrl;
    
    // サムネイルのアクティブ状態を更新
    const thumbnails = document.querySelectorAll('.product-it-thumbnail');
    thumbnails.forEach(thumb => {
      thumb.classList.remove('active');
    });
    element.classList.add('active');
  }
}

// 数量増加
function increaseQuantity(sectionId) {
  const input = document.getElementById(`Quantity-${sectionId}`);
  if (input) {
    const currentValue = parseInt(input.value) || 1;
    input.value = currentValue + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

// 数量減少
function decreaseQuantity(sectionId) {
  const input = document.getElementById(`Quantity-${sectionId}`);
  if (input) {
    const currentValue = parseInt(input.value) || 1;
    if (currentValue > 1) {
      input.value = currentValue - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

// タブ切り替え
function switchTab(event, tabName) {
  // すべてのタブコンテンツを非表示
  const tabContents = document.querySelectorAll('.tab-content');
  tabContents.forEach(content => {
    content.classList.remove('active');
  });

  // すべてのタブボタンを非アクティブ化
  const tabButtons = document.querySelectorAll('.tab-btn');
  tabButtons.forEach(button => {
    button.classList.remove('active');
  });

  // 選択されたタブを表示
  const selectedTab = document.getElementById(tabName);
  if (selectedTab) {
    selectedTab.classList.add('active');
  }

  // クリックされたボタンをアクティブ化
  if (event && event.currentTarget) {
    event.currentTarget.classList.add('active');
  }
}

// FAQ開閉機能（必要に応じて）
function toggleFaq(element) {
  const answer = element.nextElementSibling;
  if (answer) {
    answer.classList.toggle('show');
  }
}

// ページロード時の初期化
document.addEventListener('DOMContentLoaded', function() {
  // バリアント選択の変更を監視
  const variantSelects = document.querySelectorAll('.variant-select');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      updateVariant();
    });
  });

  // 数量入力の検証
  const quantityInputs = document.querySelectorAll('.quantity-input');
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      const value = parseInt(this.value);
      if (isNaN(value) || value < 1) {
        this.value = 1;
      }
    });
  });
});

// バリアント更新処理（Shopify標準機能と連携）
function updateVariant() {
  // この関数はShopifyのテーマによって異なる実装が必要な場合があります
  // 基本的にはShopify Ajaxカート機能と連携します
}

// スムーズスクロール（タブクリック時にページ上部にスクロール）
function scrollToTabs() {
  const tabsSection = document.querySelector('.product-it-tabs');
  if (tabsSection) {
    const headerOffset = 100;
    const elementPosition = tabsSection.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}